import { useQuery } from '../../lib';
import { useTribeClient } from '../../useTribeClient';
import { getAuthMemberSessionsKey } from '../../utils/keys';
export const useAuthMemberSessions = (options) => {
    const { useQueryOptions, fields = 'basic' } = options || {};
    const { client } = useTribeClient();
    const authMemberSessionsKey = getAuthMemberSessionsKey();
    return useQuery(authMemberSessionsKey, () => client.auth.authMember({ activeSession: fields, sessions: fields }), {
        ...useQueryOptions,
    });
};
//# sourceMappingURL=useAuthMemberSessions.js.map